import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _map from "lodash/map";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import createQueryHook from '@segment/utils/createQueryHook';
import { createFsCacheProxy } from '@segment/utils/fsCache';
import { useStaticSiteBackend } from '@segment/contexts/staticSiteBackend';
import { getPastEvents, toEventCard, toMonthlyEvents } from '.';
export var fetchEvents = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(client) {
    var filters,
        searchParams,
        result,
        todaysDate,
        _args = arguments;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            filters = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
            searchParams = new URLSearchParams();

            _map(filters, function (value, key) {
              var filterParams = value.map(function (item) {
                return item.value;
              });
              searchParams.set("fields.".concat(key).concat(filterParams.length === 1 ? "[all]" : filterParams.length > 1 ? "[in]" : ""), filterParams.toString());
            });

            _context.next = 5;
            return client.get("/content/entries/event?fields.customerSuccessTeamEvent=true&".concat(searchParams.toString()));

          case 5:
            result = _context.sent;
            todaysDate = new Date();
            todaysDate.setHours(0, 0, 0, 0);
            return _context.abrupt("return", toMonthlyEvents(result, todaysDate));

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function fetchEvents(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var fetchPastEvents = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(client) {
    var result, todaysDate;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return client.get("/content/entries/event?fields.customerSuccessTeamEvent=true");

          case 2:
            result = _context2.sent;
            todaysDate = new Date();
            todaysDate.setHours(0, 0, 0, 0);
            return _context2.abrupt("return", getPastEvents(result, todaysDate));

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function fetchPastEvents(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
export var createFetchEventsQuery = function createFetchEventsQuery(client, _ref3) {
  var filters = _ref3.filters;
  return [["events", "fetchEvents", filters !== null && filters !== void 0 ? filters : null], /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    var events;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return fetchEvents(client, filters);

          case 2:
            events = _context3.sent;
            return _context3.abrupt("return", events);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }))];
};
export var useEventsQuery = createQueryHook(createFetchEventsQuery, useStaticSiteBackend, {
  staleTime: Infinity,
  keepPreviousData: true
});
export var createFetchPastEventsQuery = function createFetchPastEventsQuery(client) {
  return [["events", "fetchPastEvents"], /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    var events;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return fetchPastEvents(client);

          case 2:
            events = _context4.sent;
            return _context4.abrupt("return", events);

          case 4:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }))];
};
export var usePastEventsQuery = createQueryHook(createFetchPastEventsQuery, useStaticSiteBackend, {
  staleTime: Infinity,
  keepPreviousData: true
});
export var fetchFeaturedEventData = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(client) {
    var enabled, filterParams, cachedFetch;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            enabled = Boolean(process.env.ENABLE_FS_CACHE);
            filterParams = new URLSearchParams();
            filterParams.set("fields.featured", "true");
            filterParams.set("order", "fields.startDate");
            _context5.next = 6;
            return createFsCacheProxy(["featuredEvent"], function () {
              return client.get("/content/entries/event?fields.customerSuccessTeamEvent=true&".concat(filterParams.toString())).then(function (data) {
                return data !== null && data !== void 0 && data.length ? toEventCard(data[0]) : null;
              });
            }, {
              enabled: enabled
            });

          case 6:
            cachedFetch = _context5.sent;
            return _context5.abrupt("return", cachedFetch());

          case 8:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function fetchFeaturedEventData(_x3) {
    return _ref6.apply(this, arguments);
  };
}();
export var createFeaturedEventQuery = function createFeaturedEventQuery(client) {
  return [["featuredEvent"], /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return fetchFeaturedEventData(client);

          case 3:
            return _context6.abrupt("return", _context6.sent);

          case 6:
            _context6.prev = 6;
            _context6.t0 = _context6["catch"](0);
            console.error("Failed to load featuredEvent.\nUnderlying error: ".concat(_context6.t0));

          case 9:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 6]]);
  }))];
};
export var useFeaturedEventQuery = createQueryHook(createFeaturedEventQuery, useStaticSiteBackend, {
  staleTime: Infinity
});